<template>
  <el-dialog
    :title="action == 'addMerchant' ? '添加商户' : '编辑商户'"
    :visible="show"
    @close="closeDialog"
    @open="openDialog"
    :close-on-click-modal="false"
  >
    <el-form :inline="true" :model="form" :rules="rules" ref="form" :label-width="formLabelWidth">

      <el-form-item
        label="商户名称"
        prop="loginName"
      >
        <el-col>
          <el-input
            v-model="form.loginName"
            autocomplete="off"
            placeholder="请输入商户登陆账号,英文和数字"
            :disabled="action == 'editMerchant'"
            style="width: 410px"
          ></el-input>
        </el-col>
      </el-form-item>
      <br>

      <el-form-item label="对接状态" prop="prodStatus">
        <el-col style="width: 140px">
          <el-select v-model="form.prodStatus" 
            placeholder="--请选择--"
            :disabled="form.prodStatus != '01'">
            <el-option label="测试对接中" value="00" :disabled="form.prodStatus === '01'"></el-option>
            <el-option label="申请上线中" value="01" :disabled="form.prodStatus === '01'"></el-option>
            <el-option label="正式运行中" value="02"></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item
          v-if="$store.state.roleId == '1070960390067716097'"
          label="所属代理"
        >
        <el-col style="width: 140px">
        <el-select
          v-model="form.agentId"
          placeholder="请选择所属代理"
          :popper-append-to-body="false"
          popper-class="eloption"
        >
        <el-option label="无" value="0"></el-option>
          <el-option
            v-for="item in agentList"
            :key="item.agentId"
            :label="item.agentId + '-' + item.agentName"
            :value="item.agentId"
          ></el-option>
        </el-select>
      </el-col>
      </el-form-item>
      <br>

      <el-form-item
        label="代收状态"
        prop="depositStatus"
      >
        <el-col style="width: 140px">
          <el-select v-model="form.depositStatus" placeholder="--请选择--">
            <el-option label="禁用" value="00"></el-option>
            <el-option label="正常" value="01"></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item
        label="代付状态"
        prop="withdrawStatus"
      >
        <el-col style="width: 140px">
          <el-select v-model="form.withdrawStatus" placeholder="--请选择--">
            <el-option label="禁用" value="00"></el-option>
            <el-option label="正常" value="01"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <br>

      <el-form-item
          v-if="$store.state.roleId == '1070960390067716097'"
          label="所属商务"
          prop="bizPersonnelId"
        >
        <el-col style="width: 140px">
        <el-select
          v-model="form.bizPersonnelId"
          placeholder="请选择所属商务"
          clearable
          :popper-append-to-body="false"
          popper-class="eloption"
        >
          <el-option
            v-for="item in personnelList"
            :key="item.bizPersonnelId"
            :label="item.bizPersonnelId + '-' + item.bizPersonnelName"
            :value="item.bizPersonnelId"
          ></el-option>
        </el-select>
      </el-col>
      </el-form-item>

      <el-form-item
        v-if="$store.state.roleId == '1070960390067716097'"
        label="添加人员"
      >
        <el-col style="width: 140px">
        <el-select
          v-model="form.addPersonnelId"
          placeholder="请选择添加人员"
          :popper-append-to-body="false"
          popper-class="eloption"
        >
          <el-option
            v-for="item in personnelList"
            :key="item.bizPersonnelId"
            :label="item.bizPersonnelId + '-' + item.bizPersonnelName"
            :value="item.bizPersonnelId"
          ></el-option>
        </el-select>
        </el-col>
      </el-form-item>
      <br>

      <el-form-item label="代收费率" prop="payinRate">
        <el-col>
          <el-input
            width="30px"
            v-model="form.payinRate"
            placeholder="代收费率"
            style="width: 140px"
          ><template slot="append">%</template></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="代付费率" prop="payoutRate">
        <el-col>
          <el-input
            v-model="form.payoutRate"
            placeholder="代付费率"
            style="width: 140px"
          ><template slot="append">%</template></el-input>
        </el-col>
        <br>
      </el-form-item>
      <br>

      <el-form-item label="代收单笔" prop="payinFee" >
        <el-col>
          <el-input
            v-model="form.payinFee"
            placeholder="代收单笔"
            style="width: 140px"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="代付单笔" prop="payoutFee">
          <el-col>
            <el-input
              v-model="form.payoutFee"
              placeholder="代付单笔"
              style="width: 140px"
            ></el-input>
          </el-col>
        </el-form-item>
        <br>

      <el-form-item label="IP白名单" prop="rcsIp">
        <el-col>
          <el-input
            v-model="form.rcsIp"
            placeholder="请输入IP,多个IP英文逗号分隔"
            style="width: 410px"
          ></el-input>
        </el-col>
      </el-form-item>
      <br>

      <el-form-item label="产品详情" prop="productDetails">
        <el-col>
          <el-input
            v-model="form.productDetails"
            type="textarea"
            placeholder="请输入产品链接及账号密码"
            style="width: 410px"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveMerchant">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SystemEdit',
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },

  created() {
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        loginName: '',
        merchantName: '',
        depositStatus: '01',
        withdrawStatus: '01',
        prodStatus: '00',
        cashDeposit: 0,
        agentId: '',
        rcsIp: '127.0.0.1',
        productDetails: '',
        notifyV2: '01',
        payinRate: '2.5',
        payoutRate: '0',
        payinFee: '0',
        payoutFee: '0',
        editPageVer: 'v5',
        bizPersonnelId: '',
        addPersonnelId: '',
      },
      agentList: [],
      personnelList: [],
      formLabelWidth: '120px',
      rules: {
        loginName: [
          { required: true, message: '请输入商户登陆账号', trigger: 'blur' },
          { min: 6, max: 20, message: '请输入6到12个字母数字', trigger: 'blur' },
        ],
        depositStatus: [
          { required: true, message: '请选择代收状态', trigger: 'blur' },
        ],
        withdrawStatus: [
          { required: true, message: '请选择代付状态', trigger: 'blur' },
        ],
        rcsIp: [
          { required: true, message: '请输入IP,英文逗号分隔', trigger: 'blur' },
        ],
        productDetails: [
          { required: true, message: '请输入产品链接及账号密码', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    agentNameChange() {},

    openDialog() {
      if (this.action == 'editMerchant') {
        this.form = Object.assign({}, this.formData)
        this.form.editPageVer = 'v5'
        this.form.agentId = this.form.agentId ==''?'0':this.form.agentId;
        this.form.freezeBalance = this.$formatter.FenToYuan(
          null,
          null,
          this.formData.freezeBalance,
          null
        )
      }

      if (this.$store.state.roleId == '1070960390067716097') {
        this.$axios
          .get('/bizSettlement/selectBizPersonnel', { params: {} })
          .then(res => {
            this.personnelList = res.data
        })
      }

      if (this.$store.state.roleId == '1070960390067716097') {
        this.$axios
          .get('/agent/selectAgentForOption', { params: {} })
          .then(res => {
            this.agentList = res.data
        })
      }


    },
    closeDialog() {
      this.form = {
        loginName: '',
        merchantName: '',
        depositStatus: '01',
        withdrawStatus: '01',
        cashDeposit: 0,
        agentId: '',
        prodStatus: '00',
        rcsIp: '127.0.0.1',
        productDetails: '',
        notifyV2: '01',
        payinRate: '2.5',
        payoutRate: '0',
        payinFee: '0',
        payoutFee: '0',
        editPageVer: 'v5',
        bizPersonnelId: '',
        addPersonnelId: '',
      }
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },

    saveMerchant() {
      if (this.action === 'addMerchant') {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.axios.post('/merchant/addMerchant', this.form).then
            (res => {

              if (res.code === 500) {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
                return false;
              }


              let filename
                var contentDisposition = res.headers['content-disposition']
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                var matches = filenameRegex.exec(contentDisposition)
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, '')
                }
                this.$message({
                  title: '提示',
                  message: "添加成功",
                  type: 'success',
                })

                let blob = new Blob([res.data], {
                  type: 'text/plain',
                })
                // 将blob对象转为一个URL
                var blobURL = window.URL.createObjectURL(blob)
                // 创建一个a标签
                var tempLink = document.createElement('a')
                // 隐藏a标签
                tempLink.style.display = 'none'
                // 设置a标签的href属性为blob对象转化的URL
                tempLink.href = blobURL
                // 给a标签添加下载属性
                tempLink.setAttribute('download', filename)
                if (typeof tempLink.download === 'undefined') {
                  tempLink.setAttribute('target', '_blank')
                }
                // 将a标签添加到body当中
                document.body.appendChild(tempLink)
                // 启动下载
                tempLink.click()
                // 下载完毕删除a标签
                document.body.removeChild(tempLink)
                window.URL.revokeObjectURL(blobURL)


                this.$bus.$emit('refresh') //通知刷新

                this.closeDialog()
            })
          } else {
            return false
          }
        })
      }

      if (this.action === 'editMerchant') {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.axios.post('/merchant/updateMerchant', this.form).then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })

                this.$bus.$emit('refresh') //通知刷新

                this.closeDialog()
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
          } else {
            return false
          }
        })
      }
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>

<style scoped>
</style>
